export const setFormViewMode = formViewMode => ({
  setState
}) => {
  setState({
    formViewMode
  });
};